// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220906/js/" + chunkId + "." + {"44":"e0e9ac40","225":"d7ede482","481":"e79e6a28","486":"b01b1bc0","770":"c1f467d2"}[chunkId] + ".0.5610437056094665.chunk.js";
};